import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../utils/ResponseConver";
import { OtherPlants } from "../components/OtherPlants";

export const Other_auxi_plant_list = () => {
  const { eng_log_basic_id } = useParams();
  const [auxiliary_List, set_Auxiliary_List] = useState("");
  const [loader, set_loader] = useState(false);

  const AUXILARY_MACHINARY_LIST_LOGBOOK_API = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      const res = await post(ApiURL.list_ship_machinary_details_st, FORM_DATA);
      if ((res?.status == true) === true) {
        const updatedData = res.response_data.map((item) => ({
          ...item,
          fields_name: item.fields_name
            .split(",")
            .map((field) => `Updated-${field.trim()}`)
            .join(", "),
        }));

        const updatedDataWithFormattedParams = updatedData.map((item) => ({
          ...item,
          selected_parameters: updateSelectedParameters(
            item.selected_parameters
          ), // This will format the selected parameters
        }));
        set_Auxiliary_List(updatedDataWithFormattedParams);
        // set_loader(false)
      }
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };
  useEffect(() => {
    AUXILARY_MACHINARY_LIST_LOGBOOK_API();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {auxiliary_List?.length > 0
              ? auxiliary_List
                  .filter((item) => item?.machine_id === 4)
                  .map((_items) => (
                    <OtherPlants
                      key={_items.id}
                      eng_log_basic_id={eng_log_basic_id}
                      _items={_items}
                    />
                  ))
              : "No data available"}
          </>
        )}
      </div>
    </>
  );
};
